enum IClaimStatus {
  PENDING = "Pending",
  APPROVED = "Approved",
  DECLINED = "Declined",
}

const ClaimStatusColor = {
  [IClaimStatus.PENDING]: "warning",
  [IClaimStatus.DECLINED]: "error",
  [IClaimStatus.APPROVED]: "processing",
}

const claimStatusIterable = [
  { label: "All", value: "All" },
  { label: "Approved", value: "Approved" },
  { label: "Declined", value: "Declined" },
  { label: "Pending", value: "Pending" },
  { label: "Funded", value: "Funded" },
]

export { ClaimStatusColor, IClaimStatus, claimStatusIterable }
